<template>
	<div id="ShippingRequestComponent" class="shipping-request-component">
		<button ref="btnGetShippingRequest" @click="showShippingRequestLocal" v-show="false">Buscar ShippingRequest</button>
		<button ref="btnClearObjectShippingRequest" @click="clearObjectShippingRequest" v-show="false">Limpiar Objeto ShippingRequest</button>
		<div v-if="searchingShippingsRequest" class="text-center">
			Buscando Solicitud de envío Nº {{ id }}
		</div>
		<div v-else class="shippingRequest">
			<div>
				<div>
					<div>
						<h6 v-if="isNewShippingsRequest">
							Nueva Solicitud de Envío
						</h6>
						<h6 v-else>
							Solicitud de Envío Nº {{ objectShippingRequest.id }} - <span :class="'border-bottom border-' + objectShippingRequest.color">{{ objectShippingRequest.status }}</span><small class="float-right text-muted mr-2">{{ objectShippingRequest.created_at }}</small>
						</h6>
					</div>
					<hr>
					<div class="row">
						<div class="col-3 border-right border-secondary" v-if="!isNewShippingsRequest">
							<div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
								<button class="nav-link active" id="v-pills-shippingRequestRecipientData-tab" data-toggle="pill" data-target="#v-pills-shippingRequestRecipientData" type="button" role="tab" aria-controls="v-pills-shippingRequestRecipientData" aria-selected="true">Datos de Envío</button>
								<button class="nav-link" id="v-pills-genesys-tab" data-toggle="pill" data-target="#v-pills-genesys" type="button" role="tab" aria-controls="v-pills-genesys" aria-selected="false">Vinculo Genesys</button>
								<button class="nav-link" id="v-pills-order-tab" data-toggle="pill" data-target="#v-pills-order" type="button" role="tab" aria-controls="v-pills-order" aria-selected="false">Orden</button>
								<button class="nav-link" id="v-pills-shipping-tab" data-toggle="pill" data-target="#v-pills-shipping" type="button" role="tab" aria-controls="v-pills-shipping" aria-selected="false">Envío</button>
								<button class="nav-link" id="v-pills-tracing-tab" data-toggle="pill" data-target="#v-pills-tracing" type="button" role="tab" aria-controls="v-pills-tracing" aria-selected="false">Seguimiento</button>
							</div>
						</div>
						<div :class="(!isNewShippingsRequest) ? 'col-9': 'col-12'">
							<div class="tab-content" id="v-pills-tabContent text-12">
								<div class="tab-pane fade show active" id="v-pills-shippingRequestRecipientData" role="tabpanel" aria-labelledby="v-pills-shippingRequestRecipientData-tab" v-if="objectShippingRequest.shipping_request_recipient_data != null">
									<div v-show="needGenesys && !skipDataGenesys">
										<div class="form-group row">
											<label class="col-sm-6 col-form-label text-right">Tipo de Comprobante: </label>
											<div class="col-sm-6">
												<div v-for="(item, index) in listTipocomp" :key="index" class="form-check form-check-inline" :title="item.tipocompdesc" v-if="item.view">
													<input class="form-check-input" type="radio" name="inlineRadioOptionsTipocomp" :id="'inlineRadioTipocomp' + index" :value="item.tipocompcod" v-model="tipocompcodSearch" :disabled="searchingMovimiento">
													<label class="form-check-label" :for="'inlineRadioTipocomp' + index">{{ item.sintetico }}</label>
												</div>
											</div>
										</div>
										<div class="form-group row">
											<label class="col-sm-6 col-form-label text-right" for="nrocomp">Número de Comprobante: </label>
											<div class="col-sm-4">
												<input type="number" class="form-control form-control-sm" id="nrocomp" placeholder="" ref="nrocomp" v-model="objectCabmov.nrocomp" v-on:keyup.enter="getMovimientoLocal(tipocompcodSearch, objectCabmov.nrocomp)" :disabled="searchingMovimiento" @keyup="eventKeyupnrocomp">
												<small id="emailHelp" class="form-text text-muted">{{ objectCabmov.fecmov }} - {{ objectCabmov.succod }} | {{ objectCabmov.codbareti }}</small>
											</div>
											<div class="col-sm-1">
												<button class="btn btn-primary btn-sm" @click="getMovimientoLocal(tipocompcodSearch, objectCabmov.nrocomp)">
													<i class="fas fa-search"></i>
												</button>
											</div>
										</div>
										<div class="form-group row">
											<label class="col-sm-6 col-form-label text-right" for="nrocompLegal">Documento Legal: </label>
											<div class="col-sm-2">
												<input type="number" class="form-control form-control-sm" id="nrocompLegal" placeholder="" v-model="objectCabmov.nrocompLegal" :disabled="searchingMovimiento" @keyup="eventKeyupnrocompLegal">
												<small id="emailHelp" class="form-text text-muted">{{ objectCabmov.fecmovLegal }} - {{ objectCabmov.succodLegal }}</small>
											</div>
											<div class="col-sm-4">
												<select class="form-control form-control-sm" v-model="objectCabmov.tipocompcodLegal">
													<option value="0">NO LLEVA</option>
													<option v-for="(item, index) in listTypeLegalDocuments" :key="index" :value="item.id">{{ item.name }}</option>
												</select>
											</div>
										</div>
										<div class="form-group row">
											<label class="col-sm-6 col-form-label text-right" for="cargadoa">Cargado a: </label>
											<div class="col-sm-5">
												<input type="text" class="form-control form-control-sm" id="cargadoa" placeholder="" v-model="sendtoLocal" disabled="true">
											</div>
										</div>

										<hr>
									</div>
									<div class="form-group row">
										<label for="shippingRequestRecipientDataSendto" class="col-sm-2 col-form-label text-right">Enviar a:</label>
										<div class="col-sm-5">
											<input id="shippingRequestRecipientDataSendto" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].sendto" :readonly="!modifyShippingRequestLocal">
										</div>
										<label for="shippingRequestRecipientDataNumberDocument" class="col-sm-2 col-form-label text-right">RUT:</label>
										<div class="col-sm-3">
											<input id="shippingRequestRecipientDataNumberDocument" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].number_document" :readonly="!modifyShippingRequestLocal">
										</div>
									</div>
									<div class="form-group row">
										<label for="shippingRequestRecipientDataPhone" class="col-sm-2 col-form-label text-right">Telefono:</label>
										<div class="col-sm-3">
											<input id="shippingRequestRecipientDataPhone" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].phone" :readonly="!modifyShippingRequestLocal">
										</div>
										<label for="shippingRequestRecipientDataEmail" class="col-sm-2 col-form-label text-right">Email:</label>
										<div class="col-sm-5">
											<input id="shippingRequestRecipientDataEmail" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].email" :readonly="!modifyShippingRequestLocal">
										</div>
									</div>
									<div class="form-group row">
										<label for="shippingRequestRecipientDataAddress" class="col-sm-2 col-form-label text-right">Dirección:</label>
										<div class="col-sm-5">
											<input id="shippingRequestRecipientDataAddress" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].address" :readonly="!modifyShippingRequestLocal">
										</div>
										<label for="shippingRequestRecipientDataComuna" class="col-sm-2 col-form-label text-right">Comuna:</label>
										<div class="col-sm-3">
											<input id="shippingRequestRecipientDataComuna" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].comuna" :readonly="!modifyShippingRequestLocal">
										</div>
									</div>
									<div class="form-group row">
										<label for="shippingRequestRecipientDataTransport" class="col-sm-2 col-form-label text-right">Transporte:</label>
										<div class="col-sm-3">
											<input id="shippingRequestRecipientDataTransport" type="text" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].transport" v-if="!modifyShippingRequestLocal" readonly>
											<select id="shippingRequestRecipientDataTransport" class="form-control form-control-sm" v-model="objectShippingRequest.shipping_request_recipient_data[0].transport_id" v-else>
												<option value="0" disabled>Seleccione Transporte</option>
												<option v-for="(item, index) in listTransportsFilter" :key="index" :value="item.id">{{ item.name }}</option>
											</select>
										</div>
										<label for="shippingRequestRecipientDataComuna" class="col-sm-2 col-form-label text-right">Cobro:</label>
										<div class="col-sm-5 pt-2">
											<div class="form-check form-check-inline">
												<input type="radio" name="inlineRadioOptionsCobros" id="inlineRadioCobros" value="0" v-model="objectShippingRequest.shipping_request_recipient_data[0].paid_shipping" :disabled="!modifyShippingRequestLocal">
												<label class="pl-1 font-weight-normal" for="inlineRadioCobros'">Por Pagar</label>
											</div>
											<div class="form-check form-check-inline">
												<input type="radio" name="inlineRadioOptionsCobros" id="inlineRadioCobros" value="1" v-model="objectShippingRequest.shipping_request_recipient_data[0].paid_shipping" :disabled="!modifyShippingRequestLocal">
												<label class="pl-1 font-weight-normal" for="inlineRadioCobros'">Cta Cte</label>
											</div>
											<div class="form-check form-check-inline">
												<b class="form-check-label" for="inlineRadioCobros'">$ {{ methodFormatNumber(objectShippingRequest.total_price) }}</b>
											</div>
										</div>
									</div>
								</div>
								<div class="tab-pane fade" id="v-pills-genesys" role="tabpanel" aria-labelledby="v-pills-genesys-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th class="text-center">ID</th>
												<th class="text-center">Tipo Comprobante</th>
												<th class="text-center">Fecha Movimiento</th>
												<th class="text-center">Sucursal</th>
												<th class="text-center">Codigo de Barra</th>
												<th class="text-center">Comprobante</th>
											</tr>
										</thead>
										<tbody>
											<tr v-show="objectShippingRequest.shipping_request_genesys_cabmov.length == 0">
												<td colspan="6" class="text-center">No tiene vinculos con Genesys</td>
											</tr>
											<tr v-for="(item, index) in objectShippingRequest.shipping_request_genesys_cabmov" :key="index">
												<td class="text-center">{{ item.id }}</td>
												<td class="text-center">{{ item.tipocompcod }}</td>
												<td class="text-center">{{ item.fecmov }}</td>
												<td class="text-center">{{ item.succod }}</td>
												<td class="text-center">{{ item.codbareti }}</td>
												<td class="text-center">{{ item.nrocomp }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="tab-pane fade" id="v-pills-order" role="tabpanel" aria-labelledby="v-pills-order-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th class="text-center">ID</th>
												<th>Cliente</th>
												<th>Total</th>
												<th>Estado</th>
												<th>Tipo Orden</th>
												<th>Iglesia</th>
											</tr>
										</thead>
										<tbody>
											<tr v-show="objectShippingRequest.orders.length == 0">
												<td colspan="6" class="text-center">No tiene ordenes vinculadas</td>
											</tr>
											<tr v-for="(item, index) in objectShippingRequest.orders" :key="index">
												<td class="text-center" @click="viewAllItem(item)">{{ item.id }}</td>
												<td>{{ item.client.name }} {{ item.client.surname }}</td>
												<td>{{ methodFormatNumber(item.total) }}</td>
												<td>{{ item.status.name }}</td>
												<td>{{ item.typeOrder.name }}</td>
												<td>
													<span v-if="item.church == null"></span>
													<span v-else>{{ item.church.name }}</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="tab-pane fade" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th>Enviado a:</th>
												<th>Dirección</th>
												<th class="text-center">Cta Cte</th>
												<th class="text-center">Transporte</th>
												<th class="text-center">Order de Flete</th>
												<th class="text-center">Bultos</th>
												<th class="text-center">Peso</th>
											</tr>
										</thead>
										<tbody>
											<tr v-show="objectShippingRequest.shipping.length == 0">
												<td colspan="7" class="text-center">Aun no hay datos del empaque</td>
											</tr>
											<tr v-for="(item, index) in objectShippingRequest.shipping" :key="index">
												<td>{{ item.sendto }}</td>
												<td>{{ item.address }} - {{ item.comuna }}</td>
												<td class="text-center">
													<i class="fas fa-check text-success" v-if="item.paid_shipping == 1"></i>
													<i class="fas fa-times text-muted" v-else></i>
												</td>
												<td class="text-center" :class="'text-' + item.transports.color">{{ item.transports.name }}</td>
												<td class="text-center">{{ item.freight_order }}</td>
												<td class="text-center">{{ item.packages }}</td>
												<td class="text-center">{{ item.weight }}</td>
											</tr>
										</tbody>
									</table>
								</div>
								<div class="tab-pane fade" id="v-pills-tracing" role="tabpanel" aria-labelledby="v-pills-tracing-tab">
									<table class="table table-sm table-12">
										<thead>
											<tr>
												<th class="text-center">ID</th>
												<th>Seguimiento</th>
												<th class="text-center">Usuario</th>
												<th class="text-center">IP</th>
												<th class="text-center">Fecha</th>
											</tr>
										</thead>
										<tbody v-for="(item, index) in objectShippingRequest.shipping_request_trackings_shipping_request" :key="index">
											<td class="text-center" @click="viewAllItem(item)">{{ item.id }}</td>
											<td>{{ item.trackings_shipping_request.description }}</td>
											<td class="text-center">{{ item.user.name }}</td>
											<td class="text-center">{{ item.ipv4 }}</td>
											<td class="text-center">{{ item.created_at }}</td>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-3 row">
						<div class="col-sm-2">
							Observación
						</div>
						<div class="col-sm-10">
							<input type="text" class="form-control form-control-sm" v-model="objectShippingRequest.commentary" :readonly="!modifyShippingRequestLocal">
						</div>
					</div>
					<div class="text-right mt-3" v-show="modifyShippingRequestLocal">
						<button class="btn btn-primary btn-sm" :disabled="disableBtnSave" @click="saveShippingRequestLocal">
							<span v-if="!disableBtnSave">Guardar</span>
							<span v-else><img src="@/assets/search-color.gif" width="32px"/> Guardando...</span>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import shippingsRequest from '@/mixins/shippingsRequest'
	import transports from '@/mixins/transports'
	import genesys from '@/mixins/genesys'
	import movimiento from '@/mixins/genesys/movimiento.js'
	import domicilio from '@/mixins/genesys/domicilio.js'
	import typeLegalDocument from '@/mixins/legalDocuments/typeLegalDocument.js'
	import orders from '@/mixins/orders'

	export default {
		name: 'ShippingRequestComponent',
		mixins: [ axiosAction, errors, mixin, shippingsRequest, transports, genesys, movimiento, domicilio, typeLegalDocument, orders],
		props: ['id', 'modifyShippingRequest'],
		data () {
			return {
				skipDataGenesys: false,
				sendtoLocal: '',
				minPriceFree: 30000,
			}
		},
		computed: {
			disableBtnSave() {
				return this.savingShippingsRequest
			},
			isNewShippingsRequest() {
				return (this.objectShippingRequest.id == 0)
			},
			listTransportsFilter() {
				let list = []
				list = this.listTransports
				return list
			},
			modifyShippingRequestLocal() {
				let result = false
				result = (this.modifyShippingRequest == true)
				if(!result) {
					result = this.isRoleFullAction()
				}
				return result
			},
			withDataSend() {
				if(this.objectShippingRequest.shipping_request_recipient_data.sendto.trim().length > 2) {
					return true
				}
				return false
			}
		},
		methods: {
			analyzeResultConsultarClienteEnvioLocal(climov) {
				if(climov.length == 1) {
					this.sendtoLocal = climov[0].cargadoa
					this.getDomicilioWithCliente(climov[0].domicod)
					this.objectShippingRequest.shipping_request_recipient_data[0].transport_id = this.analyzeResultConsultarTransporteLocal(climov[0].trandesc, 'ID')
					this.objectShippingRequest.shipping_request_recipient_data[0].trasnport = this.analyzeResultConsultarTransporteLocal(climov[0].trandesc, 'NAME')
				}
			},
			analyzeResultConsultarCobroLocal(brutocomp) {
				this.objectShippingRequest.shipping_request_recipient_data[0].paid_shipping = (brutocomp < this.minPriceFree) ? 0 : 1
				this.objectShippingRequest.total_price = brutocomp
			},
			analyzeResultConsultarTransporteLocal(trandesc, typeResult) {
				let transportId = 1
				let transport = 'Retira en ACES'
				if(trandesc !== null) {
					switch (trandesc.toUpperCase().trim().replace(/(\r\n|\n|\r)/gm, "")) {
						case 'STARKEN':
						case 'TUR BUS':
						case 'TURBUS':
							transportId = 2
							transport = 'Starken'
							break;
						case 'CORREOS DE CHILE':
						case 'CORREO DE CHILE':
						case 'CORREOSDECHILE':
						case 'CORREODCHILE':
							transportId = 3
							transport = 'Correos de Chile'
							break;
						case 'RETIRA EN ACES':
							transportId = 1
							transport = 'Retira en ACES'
							break;
						default:
							transportId = 1
							transport = 'Retira en ACES'
							break;
					}
				}
				return (typeResult == 'ID') ? transportId : transport
			},
			clearObjectShippingRequestLocal() {
				this.skipDataGenesys = false
				this.clearObjectCabmov()
				this.clearObjectShippingRequest()
			},
			initComponentLocal() {
				this.clearObjectShippingRequest()
				this.getAllTransportsLocal()
				this.reportGenesys('getOPFromGenesys')
				this.rolesFullAction.push(2)
			},
			getAllTransportsLocal() {
				this.getAllTransports()
			},
			getAllTransportsResultLocal(response) {},
			getDomicilioWithClienteResultLocal(response) {
				if(response.data.data.length == 1) {
					this.objectShippingRequest.shipping_request_recipient_data[0].sendto = response.data.data[0].clinom + ' ' + response.data.data[0].cliape
					this.objectShippingRequest.shipping_request_recipient_data[0].address = response.data.data[0].domicalle
					this.objectShippingRequest.shipping_request_recipient_data[0].address = (response.data.data[0].dominro === null) ? this.objectShippingRequest.shipping_request_recipient_data[0].address : this.objectShippingRequest.shipping_request_recipient_data[0].address + ' ' + response.data.data[0].dominro
					this.objectShippingRequest.shipping_request_recipient_data[0].comuna = response.data.data[0].dptodesc + ' - ' + response.data.data[0].provdesc
					this.objectShippingRequest.shipping_request_recipient_data[0].phone = (response.data.data[0].domitel === null) ? '.' : response.data.data[0].domitel
				}

			},
			getMovimientoLocal(tipocompcod, nrocomp) {
				this.clearObjectCabmov()
				this.clearObjectShippingRequest()
				this.clearObjectOrder()
				this.getMovimiento(tipocompcod, nrocomp)
			},
			getMovimientoResultLocal(response) {
				if(response.data.data.detmov.length > 0) {
					this.setObjectOrderLocal(response.data.data)
				}
				this.analyzeResultGetMovimiento(response)
			},
			emitActionSaveShippingRequest() {
				this.$emit('actionSaveShippingRequest', this.objectShippingRequest)
			},
			eventKeyupnrocomp(e) {
				if(this.objectCabmov.tipocompcod != 0 || this.objectCabmov.tipocompcodLegal != 0 || this.objectCabmov.nrocompLegal.trim() != '') {
					this.clearObjectCabmov()
				}
			},
			eventKeyupnrocompLegal(e) {
				if(this.objectCabmov.tipocompcodLegal != 0) {
					this.objectCabmov.tipocompcodLegal = 0
					this.objectCabmov.fecmovLegal = '1900-01-01'
					this.objectCabmov.succodLegal = 0
					this.objectCabmov.codbaretiLegal = 'S/BARCODE'
				}
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'getAllTransportsResult': this.getAllTransportsResult(response); break;
					case 'getDomicilioWithClienteResult': this.getDomicilioWithClienteResult(response); break;
					case 'getMovimientoResult': this.getMovimientoResult(response); break;
					case 'getShippingRequestResult': this.getShippingRequestResult(response); break;
					case 'reportGenesysResult': this.reportGenesysResult(response); break;
					case 'saveShippingRequestResult': this.saveShippingRequestResult(response); break;
					case 'saveOrderResult': this.saveOrderResult(response); break;
					case 'saveOrderShippingRequestResult': this.saveOrderShippingRequestResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			showShippingRequestLocal() {
				this.clearObjectShippingRequestLocal()
				if(this.id != null && parseInt(this.id) > 0 && this.id != '') {
					this.skipDataGenesys = true
					this.getShippingRequest(this.id)
				}
			},
			getShippingRequestResultLocal(response) {
				if(response.data.success == false) {
					this.$emit('actionShippingRequestNotFound', this.id)
				}
			},
			reportGenesysResultLocal(response) {},
			saveOrderLocal() {
				this.saveOrderBasic(this.objectOrder)
			},
			saveOrderResultLocal(response) {
				if(response.data.success == true) {
					this.setObjectOrder(response.data.data)
					this.saveOrderShippingRequest(this.objectOrder.id, response.data.data.id)
				}
			},
			saveOrderShippingRequestResultLocal(response) {
				if(response.data.success == true) {
					this.emitActionSaveShippingRequest()
				}
			},
			saveShippingRequestLocal() {
				if(this.validDataShippingRequestLocal()) {
					this.saveShippingRequest()
				}
			},
			saveShippingRequestResultLocal(response) {
				if(response.data.success == true) {
					this.objectShippingRequest.message = response.data.message
					if(this.objectOrder.type_order_id != null) {
						this.saveOrderLocal()
					} else {
						this.emitActionSaveShippingRequest()
					}
				}
			},
			validDataShippingRequestLocal() {
				let index = this.listTransportsFilter.map(e => parseInt(e.id)).indexOf(parseInt(this.objectShippingRequest.shipping_request_recipient_data[0].transport_id))
				if(index > -1) {
					this.objectShippingRequest.shipping_request_recipient_data[0].transport = this.listTransportsFilter[index].name
				}

				let messageGenesys = ''
				let messageGenesysDocumentoLegal = ''
				let messageId = 1
				if(this.needGenesys && this.objectShippingRequest.id == 0) {
					this.objectShippingRequest.shipping_request_genesys_cabmov = []
					if(this.objectCabmov.tipocompcod == 0) {
						messageGenesys = '\n' + messageId + '- NO hay datos de Genesys'
						messageId++
					} else {
						this.setCabmovs(this.objectCabmov.tipocompcod, this.objectCabmov.fecmov, this.objectCabmov.succod, this.objectCabmov.codbareti, this.objectCabmov.nrocomp)
					}
					if(this.objectCabmov.tipocompcodLegal > 0 && !isNaN(this.objectCabmov.nrocompLegal)) {
						this.setCabmovs(this.objectCabmov.tipocompcodLegal, this.objectCabmov.fecmovLegal, this.objectCabmov.succodLegal, this.objectCabmov.codbaretiLegal, this.objectCabmov.nrocompLegal)
					} else {
						messageGenesysDocumentoLegal = '\n' + messageId + '- NO hay Documento Legal asociado'
						messageId++
					}

				}

				let messageShippingRequestRecipientData = ''
				if(this.objectShippingRequest.shipping_request_recipient_data[0].sendto.trim() == '' &&
					this.objectShippingRequest.shipping_request_recipient_data[0].address.trim() == '' &&
					this.objectShippingRequest.shipping_request_recipient_data[0].comuna.trim() == '' &&
					this.objectShippingRequest.shipping_request_recipient_data[0].phone.trim() == '' &&
					this.objectShippingRequest.shipping_request_recipient_data[0].transport_id == 0) {
						messageShippingRequestRecipientData = '\nNo hay datos de envío'
				} else if(this.objectShippingRequest.shipping_request_recipient_data[0].sendto.trim() == '' ||
							this.objectShippingRequest.shipping_request_recipient_data[0].address.trim() == '' ||
							this.objectShippingRequest.shipping_request_recipient_data[0].comuna.trim() == '' ||
							this.objectShippingRequest.shipping_request_recipient_data[0].phone.trim() == '' ||
							this.objectShippingRequest.shipping_request_recipient_data[0].transport_id == 0) {
								messageShippingRequestRecipientData = '\n- Campos de datos de envío sin completar \n   '
								messageShippingRequestRecipientData+= (this.objectShippingRequest.shipping_request_recipient_data[0].sendto.trim() == '') ? ' * Enviar a' : ''
								messageShippingRequestRecipientData+= (this.objectShippingRequest.shipping_request_recipient_data[0].address.trim() == '') ? ' * Dirección' : ''
								messageShippingRequestRecipientData+= (this.objectShippingRequest.shipping_request_recipient_data[0].comuna.trim() == '') ? ' * Comuna' : ''
								messageShippingRequestRecipientData+= (this.objectShippingRequest.shipping_request_recipient_data[0].phone.trim() == '') ? ' * Telefono' : ''
								messageShippingRequestRecipientData+= (this.objectShippingRequest.shipping_request_recipient_data[0].transport_id == 0) ? ' * Transporte' : ''
				}

				if(messageShippingRequestRecipientData != '' && messageGenesys != '' && messageGenesysDocumentoLegal != '') {
					alert('No hay nada que guardar!!!')
					return false
				}
				if(messageShippingRequestRecipientData != '' || messageGenesys != '' || messageGenesysDocumentoLegal != '')
					return confirm('ATENCION!!!' + messageGenesys + messageGenesysDocumentoLegal + messageShippingRequestRecipientData)

				return true
			},
			setObjectOrderLocal(data) {
				this.objectOrder.client_id = 1
				this.objectOrder.total = data.cabmov.brutocomp
				this.objectOrder.status_id = 30
				this.objectOrder.type_order_id = 16
				data.detmov.forEach((d, i) => {
					this.objectOrder.order_products.push({
						id: i + 1,
						product_id: d.codart,
						quantity: d.cantmov,
						price: d.precunit,
						tax: this.tax,
					})
					if(d.grupo == 'G') {
						data.grupomov.forEach(gm => {
							if(parseInt(gm.itemmovcod) == parseInt(d.itemmovcod)) {
								this.objectOrder.order_product_groups.push({
									order_product_id: i + 1,
									product_id: gm.codart,
									quantity: gm.cantmov,
									price: gm.precunit
								})
							}
						})
					}
				})
			},
		},
		mounted () {
			this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.shipping-request-component {
	.nav {
		.nav-link {
			border-radius: 0;
			color: #adb5bd;
			text-align: left;
		}
		.active {
			border-left: 2px solid #007bff;
			background-color: transparent;
			color: #6c757d;
		}

	}
}
</style>
